<div class="agreement-disclosure"
     [class.agreement-disclosure--accepted]="acceptedOnUtc"
     [class.agreement-disclosure--highlighted]="highlighted">
  <ng-container *ngIf="!acceptedOnUtc; else initialled">
    <!-- Inline spinner, not ifp-spinner-loading: that one is a whole-page blocker. -->
    <ng-template #spinner>
      <span class="agreement-disclosure__saving">
        <mat-spinner class="agreement-disclosure__spinner"
                     diameter="24"></mat-spinner>
        <span>Saving…</span>
      </span>
    </ng-template>

    <ng-container *ngIf="!isPopup; else popup">
      <mat-checkbox *ngIf="!submitting; else spinner"
                    color="primary"
                    (change)="initial($event)">Initial here</mat-checkbox>
    </ng-container>

    <ng-template #popup>
      <button *ngIf="!popupOpen"
              mat-button
              color="primary"
              type="button"
              (click)="openPopup()">Review disclosure</button>

      <!-- The original disclosure pop-up, shown above the disclosure's place in the agreement. -->
      <div *ngIf="popupOpen"
           class="agreement-disclosure__popup">
        <div class="agreement-disclosure__popup-header">
          <span class="agreement-disclosure__popup-title">Disclosure</span>
          <span>{{ position }} of {{ total }}</span>
        </div>
        <div class="agreement-disclosure__popup-content">
          <div class="agreement-disclosure__popup-accept">
            <mat-checkbox *ngIf="!submitting; else spinner"
                          color="primary"
                          (change)="initial($event)"></mat-checkbox>
          </div>
          <div class="agreement-disclosure__popup-text"
               [innerHTML]="popupText"></div>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #initialled>
    <span class="agreement-disclosure__signature">
      <span class="agreement-disclosure__initials">{{ signerInitials }}</span>
      <span class="agreement-disclosure__date">{{ acceptedOnUtc | date: "MM/dd/yyyy" }}</span>
    </span>
  </ng-template>
</div>
